import { Wallets } from '@pages/IntroducingBroker/Dashboard/Wallets/Wallets'
import { useWalletsWithLatestTransactions } from '@pages/IntroducingBroker/Dashboard/hooks/useWalletsWithLatestTransactions'

export const IBWalletWidget = () => {
  const { walletsWithLatestTransactions, isLoading } = useWalletsWithLatestTransactions()

  return (
    <Wallets walletsWithLatestTransactions={walletsWithLatestTransactions} isLoading={isLoading} />
  )
}
